import LTR from "@brand-icons/global/external-link/external-link-ltr.svg";
import RTL from "@brand-icons/global/external-link/external-link-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ExternalLinkIcon = iconFactory("ExternalLinkIcon", LTR, RTL);
